/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateJobConfigurationsDTO
 */
export interface UpdateJobConfigurationsDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateJobConfigurationsDTO
     */
    cardType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportFinalCronPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportFinalEmptyExportFiles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportFinalExcludeMissingPatients?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportFinalFtp?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportFinalMinValidCardPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportOverChargedCronPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportOverChargedEmptyExportFiles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportOverChargedExcludeMissingPatients?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobConfigurationsDTO
     */
    exportOverChargedFtp?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobConfigurationsDTO
     */
    finalizeCardCronPattern?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateJobConfigurationsDTO
     */
    finalizeHours?: number;
}

export function UpdateJobConfigurationsDTOFromJSON(json: any): UpdateJobConfigurationsDTO {
    return UpdateJobConfigurationsDTOFromJSONTyped(json, false);
}

export function UpdateJobConfigurationsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateJobConfigurationsDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardType': !exists(json, 'cardType') ? undefined : json['cardType'],
        'exportFinalCronPattern': !exists(json, 'exportFinalCronPattern') ? undefined : json['exportFinalCronPattern'],
        'exportFinalEmptyExportFiles': !exists(json, 'exportFinalEmptyExportFiles') ? undefined : json['exportFinalEmptyExportFiles'],
        'exportFinalExcludeMissingPatients': !exists(json, 'exportFinalExcludeMissingPatients') ? undefined : json['exportFinalExcludeMissingPatients'],
        'exportFinalFtp': !exists(json, 'exportFinalFtp') ? undefined : json['exportFinalFtp'],
        'exportFinalMinValidCardPeriod': !exists(json, 'exportFinalMinValidCardPeriod') ? undefined : json['exportFinalMinValidCardPeriod'],
        'exportOverChargedCronPattern': !exists(json, 'exportOverChargedCronPattern') ? undefined : json['exportOverChargedCronPattern'],
        'exportOverChargedEmptyExportFiles': !exists(json, 'exportOverChargedEmptyExportFiles') ? undefined : json['exportOverChargedEmptyExportFiles'],
        'exportOverChargedExcludeMissingPatients': !exists(json, 'exportOverChargedExcludeMissingPatients') ? undefined : json['exportOverChargedExcludeMissingPatients'],
        'exportOverChargedFtp': !exists(json, 'exportOverChargedFtp') ? undefined : json['exportOverChargedFtp'],
        'finalizeCardCronPattern': !exists(json, 'finalizeCardCronPattern') ? undefined : json['finalizeCardCronPattern'],
        'finalizeHours': !exists(json, 'finalizeHours') ? undefined : json['finalizeHours'],
    };
}

export function UpdateJobConfigurationsDTOToJSON(value?: UpdateJobConfigurationsDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardType': value.cardType,
        'exportFinalCronPattern': value.exportFinalCronPattern,
        'exportFinalEmptyExportFiles': value.exportFinalEmptyExportFiles,
        'exportFinalExcludeMissingPatients': value.exportFinalExcludeMissingPatients,
        'exportFinalFtp': value.exportFinalFtp,
        'exportFinalMinValidCardPeriod': value.exportFinalMinValidCardPeriod,
        'exportOverChargedCronPattern': value.exportOverChargedCronPattern,
        'exportOverChargedEmptyExportFiles': value.exportOverChargedEmptyExportFiles,
        'exportOverChargedExcludeMissingPatients': value.exportOverChargedExcludeMissingPatients,
        'exportOverChargedFtp': value.exportOverChargedFtp,
        'finalizeCardCronPattern': value.finalizeCardCronPattern,
        'finalizeHours': value.finalizeHours,
    };
}

